export default __webpack_public_path__ + "static/media/chat-bubble-dark-off.58257f92.svg";